import { useQueryClient } from "@tanstack/react-query";
import { Delivery } from "../../../../services/Delivery";

/**
 * Mesmo racional de `CONCESSIONARIA_BUSCA_SIZE`: maior que o `DEFAULT_PAGE_SIZE`
 * (5) para exibir ao menos 10 cidades assim que o campo aparece.
 */
const DELIVERY_BUSCA_SIZE = 10;

export const useDeliveryBusca = () => {
  const queryClient = useQueryClient();

  const buscarDeliveries = (cidade: string) => {
    return queryClient
      .fetchQuery({
        queryKey: ["delivery-busca", cidade],
        queryFn: () =>
          Delivery.get({
            cidade,
            page: 0,
            size: DELIVERY_BUSCA_SIZE,
          }),
      })
      .then(({ data }) => data);
  };

  return { buscarDeliveries };
};
